/**
 * Normaliza flags de permissão (boolean, 1 ou "true"/"1").
 * @param {unknown} value
 * @returns {boolean}
 */
export function isPermissionFlagEnabled(value) {
  if (value === true || value === 1) {
    return true;
  }

  if (value === false || value === 0 || value == null) {
    return false;
  }

  if (typeof value === "string") {
    const normalized = value.trim().toLowerCase();
    if (
      normalized === "false" ||
      normalized === "0" ||
      normalized === "no" ||
      normalized === "n"
    ) {
      return false;
    }
    return normalized === "true" || normalized === "1";
  }

  return false;
}
